import ExampleCardAlert from './ExampleCardAlert';

export default ExampleCardAlert;
